
export const ProblemSection = () => {
  const problems = [
    {
      icon: "ri-eye-off-line",
      title: "Manque de visibilité",
      description: "Vous avez du mal à vous démarquer face à la concurrence"
    },
    {
      icon: "ri-time-line",
      title: "Manque de temps",
      description: "Vous manquez de temps pour gérer la communication et le marketing"
    },
    {
      icon: "ri-user-add-line",
      title: "Difficultés d'attraction",
      description: "Vous avez des difficultés à attirer de nouveaux clients"
    },
    {
      icon: "ri-line-chart-line",
      title: "Revenus stagnants",
      description: "Vos revenus stagnent malgré tous vos efforts"
    }
  ];

  return (
    <section className="py-12 sm:py-16 md:py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-gray-900 mb-4 sm:mb-6 leading-tight">
            Les entrepreneurs ne manquent pas de talent{" "}
            <br className="hidden sm:block" />
            <span className="bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent">
              mais de visibilité
            </span>
          </h2>
          <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto font-accent px-4">
            Nous comprenons les défis auxquels vous faites face au quotidien
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
          {problems.map((problem, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-6 sm:p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-purple-200 group"
            >
              <div className="w-14 h-14 sm:w-16 sm:h-16 bg-gradient-to-br from-purple-100 to-pink-100 rounded-full flex items-center justify-center mb-4 sm:mb-6 group-hover:scale-110 transition-transform duration-300 mx-auto sm:mx-0">
                <i className={`${problem.icon} text-xl sm:text-2xl text-purple-600`}></i>
              </div>
              <h3 className="text-lg sm:text-xl font-heading font-bold text-gray-900 mb-3 sm:mb-4 text-center sm:text-left">
                {problem.title}
              </h3>
              <p className="text-gray-600 leading-relaxed font-primary text-sm sm:text-base text-center sm:text-left">
                {problem.description}
              </p>
            </div>
          ))}
        </div>

        <div className="text-center mt-12 sm:mt-16">
          <div className="inline-flex items-center bg-purple-50 border border-purple-300 rounded-full px-6 sm:px-8 py-3 sm:py-4 mx-4">
            <i className="ri-alert-line text-purple-400 text-lg sm:text-xl mr-2 sm:mr-3"></i>
            <span className="text-purple-400 font-accent font-semibold text-sm sm:text-lg">
              Ces problèmes limitent votre croissance et votre potentiel
            </span>
          </div>
        </div>

      </div>
    </section>
  );
};
